import type { ReactNode } from 'react';

/**
 * Renders the loading / error envelope for a query so every list surfaces those
 * states consistently (Req 6.5 — loading/error handled by the query layer). When
 * neither is active, `children` renders with the loaded data.
 */
export function QueryState({
  isLoading,
  isError,
  label,
  children,
}: {
  isLoading: boolean;
  isError: boolean;
  label: string;
  children: ReactNode;
}) {
  if (isLoading) {
    return (
      <p role="status" className="muted">
        Loading {label}…
      </p>
    );
  }
  if (isError) {
    return (
      <p role="alert" className="error">
        Could not load {label}.
      </p>
    );
  }
  return <>{children}</>;
}
